// extracted by mini-css-extract-plugin
export default {"sns_container":"sns_container__e12baf05","sns_icon":"sns_icon__e12baf05"};